module.exports = __webpack_public_path__ + "static/media/cartoes_amex.f90c4b36.svg";